import { useState } from "react";
import { connect } from "react-redux";
import {Alert, Card, Grid} from "@mui/material";
import { Check as CheckIcon } from "@mui/icons-material";
import { LoadingButton } from '@mui/lab';
import { t } from "i18next";
import api from "../../../../helpers/api/Api";
import ApiUrls from "../../../../helpers/urls/ApiUrls";
import { setCommit } from "../../../../redux/actions";
import { showStatus } from "../../../../helpers/api/errors/ShowStatus";
import MDBox from "../../../../components/MDs/MDBox";
import DashboardLayout from "../../../../components/LayoutContainers/DashboardLayout";
import CustomDialog from "../../../../components/Dialog";

function Commit({ setCommit }) {
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [alert, setAlert] = useState(false);

  const toCommit = () => {
    setOpenDialog(true);
  }

  const commit = () => {
    setLoading(true);

    api.get(ApiUrls.commit)
      .then((response) => {
        setLoading(false);
        if (response.data.status === "toofast") {
          setAlert(true);
        } else {
          let error = false;
          const data = response.data;
          for (let i = 0; i < data.length; i++) {
            const res = data[i].result;
            for (let j = 0; j < res.length; j++) {
              if (res[j].status === "error") {
                error = true;
                break;
              }
            }
          }

          if (!error) {
            setCommit(false);
          }

          showStatus(error ? "commit_error" : "commit_success");
        }
        handleCloseDialog();
      })
      .catch((error) => {
        setLoading(false);
        handleCloseDialog();
        showStatus("commit_error");
      });
  }

  const handleCloseDialog = () => {
    setOpenDialog(false);
  }

  return (
    <>
      <DashboardLayout>
        <Card className="mt-5">
          <MDBox py={5} px={5}>
            <Grid container spacing={2} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
              {alert &&
                 <div className="d-flex justify-content-center">
                   <Grid item xs={12} mt={3} mb={3}>
                     <Alert severity="error">
                       {t("domain.too_fast_error")}
                     </Alert>
                   </Grid>
                 </div>
              }

              <p>
                {t("commit.page_paragraph")}
              </p>

              <Grid item md={4} mt={3}>
                <LoadingButton
                  color="error"
                  loading={loading}
                  startIcon={<CheckIcon />}
                  variant="contained"
                  fullWidth
                  onClick={toCommit}
                >
                  {t("button.run")}
                </LoadingButton>
              </Grid>
            </Grid>
          </MDBox>
        </Card>
      </DashboardLayout>

      <CustomDialog
        open={openDialog}
        text={t("commit.commit_confirm")}
        handleClose={handleCloseDialog}
        onAccept={commit}
        loading={loading}
      />
    </>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    setCommit: data => dispatch(setCommit(data))
  }
}

export default connect(null, mapDispatchToProps)(Commit);
